module.exports = __webpack_public_path__ + "img/3.277fc159.png";